import isEmpty from 'lodash.isempty';
import { sharedHelpers } from 'shared-helpers';
import newsApi from '../../apis/newsApi';

import { OLD_URLS_REGEX } from '../constants';


// shared helpers section
export const getItemWebUrl = sharedHelpers.getItemWebUrl;
export const timeDiff = sharedHelpers.timeDiff;
export const queryString = sharedHelpers.queryString;
export const deserializeData = sharedHelpers.deserializeData;
export const checkEmailStatus = sharedHelpers.checkEmailStatus;
export const isValidEmail = sharedHelpers.isValidEmail;

/**
 * Method to convert the URLs from the old structure (/news/:id/:code) to the new structure (/news/:slug)
 * 
 * @param link      link object
 */
export const getNewUrl = (link) => {    
    let newUrl = '';

    // check if the link has a query string
    const qStringArr    = link.split('?');
    const qString       = (qStringArr.length > 1) ? qStringArr[qStringArr.length - 1] : '';

    // https://magnitt.com/:path/:id/:code/:action e.g https://magnitt.com/research/12345/research-code/buy
    // the split will generate a similar array ["http:", "", "magnitt.com", "research", "12345", "research-code", "buy"]
    const arLink    = qStringArr[0].split('/');
    const id        = arLink[4]
    const code      = arLink[5]
    const action    = arLink[6] ? arLink[6] : ''
    const slug      = `${code}-${id}`

    arLink.splice(4,3)
    arLink.push(slug)

    if (action !== '') {   
        arLink.push(action)
    }
    
    if (!isEmpty(qString)) {
        newUrl = arLink.join('/') + `?${qString}`
    } else {
        newUrl = arLink.join('/')
    }

    return newUrl
}

/**
 * Method to check if the content body of the news article or the research has an anchor tag that leads to magnitt news, research, or an ICE entity
 * then replace the old url structure (/entity/id/code) with the new url structure (/entity/slug)
 * then update the content body.
 * @param {Object} data              Request data
 * @param {String} categoryUTM       News category UTM link
 */
export const handleBodyLinks = (data = {}, categoryUTM = "") => {
    if (!isEmpty(data) && data.body) {
        let dataObj = data;

        const updatedDom = data.body.replace(/(href="([^"]+)")/g, (val) => {
            let link = val.split('href=')[1].replace(/['"]+/g, '');

            if (!link.includes("?") && categoryUTM) {
                link = link + `?${categoryUTM}`;
            }

            if (OLD_URLS_REGEX.news.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else if (OLD_URLS_REGEX.research.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else if (OLD_URLS_REGEX.investors.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else if (OLD_URLS_REGEX.enablers.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else if (OLD_URLS_REGEX.corporates.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else if (OLD_URLS_REGEX.startups.test(link)) {
                const updateLink = getNewUrl(link);
                return `href="${updateLink}"`;
            }
            else {
                return `href="${link}"`;
            }
        });

        dataObj.body = updatedDom;
        
        return dataObj;
    } else {
        return data;
    }
}

/**
 * Method to update the links in the news article body by converting them to the new structure and adding the category UTM link 
 * @param {Object} data             Request data
 * @param {String} token            User access token
 * @param {String} refreshToken     User refresh token
 */
export const handleNewsBodyOperations = async (data = {}, token = "", refreshToken = "") => {
    try {
        let finalData = data;

        if (!isEmpty(data) && data.news_category_data && data.news_category_data.length > 0) {
            const tempObj = !isEmpty(data.news_category_data[0]) ? data.news_category_data[0] : {};
    
            if (!isEmpty(tempObj) && tempObj.id) {
                const response = await newsApi.getNewsUTMLinKByCategory(tempObj.id, token, refreshToken);
    
                if (response && response.length > 0 && response[0].utm_link) {
                    finalData = handleBodyLinks(data, response[0].utm_link);
                    finalData.utm_link = response[0].utm_link;
                } else {
                    finalData = handleBodyLinks(data);
                }
                
                return finalData;
            } else {
                finalData = handleBodyLinks(data);
            }
        } else {
            finalData = handleBodyLinks(data);
        }
    
        return finalData;
    } catch (error) {
        return handleBodyLinks(data);
    }
}

/** 
 * method to sort objects in an array alphabetically
 * using toUpperCase for a case insensitive sort
 * @param sortField - results should be sorted by this parameter
 * @param array     - array to be sorted
 */

export const alphabeticalSort = (array, sortField) => {
    array.sort(function (a, b) {
        const textA = a[sortField].toUpperCase();
        const textB = b[sortField].toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    return array;
}

export const trimText = (text) => {
    let body = '';
    if (text !== undefined && text !== null) {
        body = text.replace(/<\/?[^>]+(>|$)/g, '');
        body = body.replace(/&nbsp;/g, ' ');
        body = body.replace(/&#39;/g, "'")
        body = body.replace(/&quot;/g, '"')
        body = body.replace(/&rsquo;/g, "’")
        if (body !== undefined && body !== null && body.length > 300) {
            body = body.substr(0, 300);
            body = body.substr(0, body.lastIndexOf(' ')) + ' ...';
        }
    }
    return body;
}

export const modifyElementsForSEO = (object) => {
    // Parse the HTML content of object.body
    const parser = new DOMParser();
    const doc = parser.parseFromString(object.body, 'text/html');

    // Find all <a> tags in the parsed HTML
    const aTags = doc.querySelectorAll('a');

    aTags.forEach((aTag) => {
        // Check if the <a> tag does not have an href attribute
        if (!aTag.hasAttribute('href')) {
            // Replace the <a> tag with a <span> tag
            const spanTag = document.createElement('span');
            spanTag.className = 'a-tag-style';

            // Copy all attributes from the <a> tag to the <span> tag
            Array.from(aTag.attributes).forEach((attr) => {
                spanTag.setAttribute(attr.name, attr.value);
            });

            // Check if the child of the <a> tag is a text node
            if (aTag.childNodes.length === 1 && aTag.childNodes[0].nodeType === Node.TEXT_NODE) {
                spanTag.style.textDecoration = 'underline';
                spanTag.style.textUnderlineOffset = '3px';
            }

            spanTag.innerHTML = aTag.innerHTML; // Preserve the inner content of the <a> tag
            aTag.replaceWith(spanTag);
        }
    });

    // Check if the first child is an h3, h4, or h6 and replace it with h2
    const firstElement = doc.body.firstElementChild;
    if (firstElement && ['H3', 'H4', 'H6'].includes(firstElement.tagName) && firstElement.classList.contains('heading-1')) {
        const newHeading = doc.createElement('h2');

        // Copy all attributes from the original heading to the new heading
        Array.from(firstElement.attributes).forEach(attr => {
            newHeading.setAttribute(attr.name, attr.value);
        });

        newHeading.innerHTML = firstElement.innerHTML; // Preserve the content
        doc.body.replaceChild(newHeading, firstElement);
    }

    return doc.body.innerHTML;
}
